import { Watchlist } from "../../components/ContinueWatching/Watchlist";
import Bottom from "../../components/Layouts/Bottom";
import React from "react";

function ContinueWatching() {
  return (
    <>
      <div className="full-sec"><div className="right-sec">
          <Watchlist />
        </div>
      </div>
      <Bottom />
    </>
  );
}

export default ContinueWatching;
